import * as i0 from "@angular/core";
var ApiConfigService = /** @class */ (function () {
    function ApiConfigService() {
    }
    ApiConfigService.ngInjectableDef = i0.defineInjectable({ factory: function ApiConfigService_Factory() { return new ApiConfigService(); }, token: ApiConfigService, providedIn: "root" });
    return ApiConfigService;
}());
export { ApiConfigService };
